import { produce } from 'immer'
import type { State } from '../typings'

export type SetCloseableAction = {
  type: 'setCloseable'
  payload: boolean
}

export const setCloseableProducer = produce<
  State,
  [SetCloseableAction['payload']]
>((draft, payload) => {
  draft.canClose = payload
})

export const setCloseableActionCreator = (
  payload: SetCloseableAction['payload'],
): SetCloseableAction => ({
  type: 'setCloseable',
  payload,
})
